module.exports = __webpack_public_path__ + "img/Grupos.0b5ff431.svg";